// extracted by mini-css-extract-plugin
export var colorSquare = "_ql-0";
export var danger = "_ql-5";
export var lightPink = "_ql-8";
export var neutralBlue = "_ql-7";
export var neutralYellow = "_ql-6";
export var normal = "_ql-1";
export var primary = "_ql-2";
export var primaryLight = "_ql-3";
export var solidBlack = "_ql-g";
export var solidGreen = "_ql-b";
export var solidLightBlue = "_ql-d";
export var solidNavy = "_ql-c";
export var solidOrange = "_ql-f";
export var solidPink = "_ql-e";
export var solidRed = "_ql-9";
export var solidYellow = "_ql-a";
export var success = "_ql-4";